import React, { Component } from "react";

import Graphemer from "graphemer";
import emoji from "react-easy-emoji";

const splitter = new Graphemer();

class BodyMessage extends Component {
  render() {
    const { rawMessage } = this.props;

    let test_str = "";
    let res = [];
    test_str = rawMessage;
    if (rawMessage) {
      test_str = test_str.replaceAll("```", "∋");
      res = splitter.splitGraphemes(test_str);
    }
    let classBold = "";
    let classItalic = "";
    let classStrike = "";
    let classCour = "";
    let classFinal = "";
    let count = 0;
    let countItalic = 0;
    let countStrike = 0;
    let countCour = 0;
    let arrayElement = [];

    let idxboldfirst = 0;
    let idxboldsec = 0;
    let idxitalfirst = 0;
    let idxitalsec = 0;
    let idxstrikefirst = 0;
    let idxstrikesec = 0;
    let idxcourfirst = 0;
    let idxcoursec = 0;
    let element = "";
    let backtick = "```";
    let backtickone = "∋";
    for (let i = 0; i < res.length; i++) {
      if (res[i] === "*") {
        if (res[i] !== "*" || res[i] !== "_") {
          element = res[i];
        }
        count += 1;
        if (count === 1) idxboldfirst = i;
        if (count !== 0 && count % 2 == 0) {
          classBold = "font-weight-bold";
        } else {
          classBold = "";
          element = "*";
          arrayElement.push(
            <span key={`preview-${i}`} className={classFinal}>
              {emoji(element)}
            </span>
          );
        }
        if (count === 2) {
          idxboldsec = i;
          if (
            res[idxboldfirst + 1] === " " ||
            res[idxboldfirst + 1] === "\n" ||
            res[idxboldsec - 1] === " " ||
            res[idxboldsec - 1] === "\n" ||
            (res[idxboldsec - 1] === "*" && res[idxboldfirst + 1] === "*")
          ) {
            arrayElement.push(
              <span key={`preview-${i}`} className={classFinal}>
                {emoji(element)}
              </span>
            );
            count = 1;
            classBold = "";
            idxboldfirst = i;
            continue;
          }

          for (let j = idxboldfirst; j <= idxboldsec; j++) {
            classFinal = `${classBold} ${classItalic}`;
            arrayElement[j] = (
              <span key={`preview-${i}-${j}`} className={classFinal}>
                {emoji(res[j] === "*" ? "" : res[j])}
              </span>
            );
          }
          count = 0;
          classBold = "";
        }
      } else if (res[i] === "_") {
        if (res[i] !== "*" || res[i] != "_") {
          element = res[i];
        }
        countItalic += 1;
        if (countItalic === 1) idxitalfirst = i;
        if (countItalic !== 0 && countItalic % 2 == 0) {
          classItalic = "font-style-italic";
        } else {
          classItalic = "";
          element = "_";
          arrayElement.push(
            <span key={`preview-${i}`} className={classFinal}>
              {emoji(element)}
            </span>
          );
        }
        if (countItalic === 2) {
          idxitalsec = i;
          if (
            res[idxitalfirst + 1] === " " ||
            res[idxitalfirst + 1] === "\n" ||
            res[idxitalsec - 1] === " " ||
            res[idxitalsec - 1] === "\n" ||
            (res[idxitalsec - 1] === "_" && res[idxitalfirst + 1] === "_")
          ) {
            arrayElement.push(
              <span key={`preview-${i}`} className={classFinal}>
                {emoji(element)}
              </span>
            );
            countItalic = 1;
            classItalic = "";
            idxitalfirst = i;
            continue;
          }
          for (let k = idxitalfirst; k <= idxitalsec; k++) {
            classFinal = `${classBold} ${classItalic}`;
            arrayElement[k] = (
              <span key={`preview-${i}-${k}`} className={classFinal}>
                {emoji(res[k] === "_" ? "" : res[k])}
              </span>
            );
          }
          countItalic = 0;
          classItalic = "";
        }
      } else if (res[i] == "~") {
        if (res[i] !== "*" || res[i] !== "_" || res[i] !== "~") {
          element = res[i];
        }
        countStrike += 1;
        if (countStrike === 1) idxstrikefirst = i;
        if (countStrike !== 0 && countStrike % 2 === 0) {
          classStrike = "line_through";
        } else {
          classStrike = "";
          element = "~";
          arrayElement.push(
            <span key={`preview-${i}`} className={classFinal}>
              {emoji(element)}
            </span>
          );
        }
        if (countStrike == 2) {
          idxstrikesec = i;
          if (
            res[idxstrikefirst + 1] === " " ||
            res[idxstrikefirst + 1] === "\n" ||
            res[idxstrikesec - 1] === " " ||
            res[idxstrikesec - 1] === "\n" ||
            (res[idxstrikesec - 1] === "~" && res[idxstrikefirst + 1] === "~")
          ) {
            arrayElement.push(
              <span key={`preview-${i}`} className={classFinal}>
                {emoji(element)}
              </span>
            );
            countStrike = 1;
            classStrike = "";
            idxstrikefirst = i;
            continue;
          }
          for (let k = idxstrikefirst; k <= idxstrikesec; k++) {
            classFinal = `${classBold} ${classItalic} ${classStrike}`;
            arrayElement[k] = (
              <span key={`preview-${i}-${k}`} className={classFinal}>
                {emoji(res[k] == "~" ? "" : res[k])}
              </span>
            );
          }
          countStrike = 0;
          classStrike = "";
        }
      } else if (res[i] == backtickone) {
        if (
          res[i] !== "*" ||
          res[i] !== "_" ||
          res[i] !== "~" ||
          res[i] !== backtickone
        ) {
          element = res[i];
        }
        countCour += 1;
        if (countCour === 1) idxcourfirst = i;
        if (countCour !== 0 && countCour % 2 === 0) {
          classCour = "line_courier";
        } else {
          classCour = "";
          element = backtick;
          arrayElement.push(
            <span key={`preview-${i}`} className={classFinal}>
              {emoji(element)}
            </span>
          );
        }
        if (countCour === 2) {
          idxcoursec = i;
          if (
            res[idxcourfirst + 1] === " " ||
            res[idxcourfirst + 1] === "\n" ||
            res[idxcoursec - 1] === " " ||
            res[idxcoursec - 1] === "\n" ||
            (res[idxcoursec - 1] === backtickone &&
              res[idxcourfirst + 1] === backtickone)
          ) {
            if (element === backtickone) element = backtick;
            arrayElement.push(
              <span key={`preview-${i}`} className={classFinal}>
                {emoji(element)}
              </span>
            );
            countCour = 1;
            classCour = "";
            idxcourfirst = i;
            continue;
          }
          for (let k = idxcourfirst; k <= idxcoursec; k++) {
            classFinal = `${classBold} ${classItalic} ${classStrike} ${classCour}`;
            arrayElement[k] = (
              <span key={`preview-${i}-${k}`} className={classFinal}>
                {emoji(res[k] === backtickone ? "" : res[k])}
              </span>
            );
          }
          countCour = 0;
          classCour = "";
        }
      } else {
        let classpace = "";
        if (
          res[i] !== "*" ||
          res[i] !== "_" ||
          res[i] !== "~" ||
          res[i] !== backtickone
        ) {
          element = res[i];
        }
        if (element === " ") {
          classpace = "emptysp";
        }
        classFinal = `${classBold} ${classItalic} ${classStrike} ${classCour} ${classpace}`;
        arrayElement.push(
          <span key={`preview-${i}`} className={classFinal}>
            {emoji(element)}
          </span>
        );
      }
    }

    return <p>{arrayElement.map((data, i) => data)}</p>;
  }
}

export default BodyMessage;
